/*
 * @Author: weijinpeng
 * @LastEditors: weijinpeng
 * @Date: 2025-08-13 15:50:56
 * @LastEditTime: 2025-08-14 15:20:50
 * @Description: 
 */
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './en'
import zh from './zh'

Vue.use(VueI18n)

const i18n = new VueI18n({
    locale: localStorage.getItem('lang') || 'en', // 默认语言
    fallbackLocale: 'en',
    messages: {
        en,
        zh
    }
})

export default i18n